<script>
import { get } from "lodash";
import { fandomBasicMixin, fandomExtendedMixin } from "src/modules/fandom_mixins_module.js";

export default {
  mixins: [fandomBasicMixin, fandomExtendedMixin],
  computed: {
    user() {
      return get(globalState, ["pageModel", "user"], {});
    },
    name() {
      return [this.user.first_name, this.user.last_name].filter(Fandom.exists).join(" ");
    }
  },
  created() {
    if (this.content.theme) {
      this.content.stripes.forEach((stripe) => {
        if (!Fandom.exists(stripe.theme)) {
          Vue.set(stripe, "theme", this.content.theme);
        }
      });
    }
  },
};
</script>

<template>
  <div class="poisition-relative" v-easyadmin="easyadminId" :class="[contentType, {'secondary-navbar-present': !!content.navbar}, theme]" v-if="isContentVisibleToUser()" >
    <div class="w-100 bg-vodafone">
      <div class="container">
        <div class="row align-items-center user-greetings">
          <div class="col-12 text-white h3 font-weight-light">
            <span class="opacity-65">{{ft("globals.hello")}}</span>
            <span>{{name}}</span>
          </div>
        </div>
      </div>
    </div>
    <component :is="getContent(content.navbar).layout" :content="getContent(content.navbar)" v-if="content.navbar" :animation="false" :sticky="true"></component>
    <component :is="stripe.layout" :content="stripe" v-for="(stripe, index) in content.stripes" :key="stripe.$id" :opt-container-content="containerContent" :class="{'first': !index}"></component>
  </div>
</template>

<style lang="scss">
.user-greetings {
  min-height: 9rem;
}

.opacity-65 {
  opacity: .65;
}

.secondary-navbar-present {
  .breadcrumb-container {
    top: $secondary-nav-height;
  }

  .first {
    .mh-100vh-header {
      min-height: calc(100vh - #{$header-height} - #{$secondary-nav-height});
    }

    .h-100vh-header {
      height: calc(100vh - #{$header-height} - #{$secondary-nav-height});
    }
  }
}
</style>
